import TableRow from "@mui/material/TableRow";

export const Item = ({
                         children,
                     }) => {
    return (
        <TableRow>
            {children}
        </TableRow>
    );
};

export default Item;